import React, { FunctionComponent, ReactElement } from 'react';
import styled from 'styled-components';
import { useMedia, createMediaMatcher } from 'react-media-match';
import getIconSet from '@empiriecom/module-components/utils/getIconSet';

const NavButton = styled.button<{ isDisabled: boolean }>`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  cursor: pointer;
  border: 0px none;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 6px 10px 0 rgba(0, 0, 0, 0.14);
  background-color: #ffffff;
  margin: 0;
  padding: 0;
  transition: opacity 0.5s;
  transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
  will-change: opacity;
  outline: none;
  position: absolute;
  z-index: 10;
  top: 50%;
  transform: translateY(-50%);
  ${({ isDisabled }) => (isDisabled ? 'opacity: 0; pointer-events: none;' : 'opacity: 1;')}
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonPrev = styled(NavButton)<{ isTablet: boolean }>`
  left: ${({ isTablet }) => (isTablet ? '0' : '-1.25rem')};
`;

const ButtonNext = styled(NavButton)<{ isTablet: boolean }>`
  right: ${({ isTablet }) => (isTablet ? '0' : '-1.25rem')};
`;

interface ArrowProps {
  isDisabled: boolean;
  type: 'NEXT' | 'PREV';
  onClick: () => void;
}

export const Arrow: FunctionComponent<ArrowProps> = ({
  isDisabled = false,
  type,
  onClick,
}): ReactElement => {
  const { ArrowMediumLeft: ArrowLeft, ArrowMediumRight: ArrowRight } = getIconSet();
  let element: ReactElement;
  const orientation = createMediaMatcher({
    landscape: '(orientation: landscape) and (max-width : 1026px)',
    portrait: '(orientation: portrait) and (min-width : 766px) and (max-width : 1026px)',
  });
  const isTablet = useMedia({
    desktop: orientation.useMedia({ landscape: true, portrait: true }),
    mobile: false,
    tablet: orientation.useMedia({ landscape: true, portrait: true }),
  });
  if (type === 'NEXT') {
    element = (
      <ButtonNext
        data-testid="arrow-next"
        disabled={isDisabled}
        isDisabled={isDisabled}
        onClick={!isDisabled ? onClick : null}
        isTablet={isTablet}
      >
        <ArrowRight />
      </ButtonNext>
    );
  }
  if (type === 'PREV') {
    element = (
      <ButtonPrev
        data-testid="arrow-prev"
        disabled={isDisabled}
        isDisabled={isDisabled}
        onClick={!isDisabled ? onClick : null}
        isTablet={isTablet}
      >
        <ArrowLeft />
      </ButtonPrev>
    );
  }
  return element;
};

export default Arrow;
